import { SVGProps } from 'react';

export const MicrophoneOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 0 121 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M114 76C114 105.271 90.0472 129 60.5 129C30.9528 129 7 105.271 7 76"
        stroke="currentColor"
        strokeWidth={14}
        strokeLinecap="round"
      />
      <rect x={33} y={7} width={56} height={97} rx={28} stroke="currentColor" strokeWidth={14} />
      <rect x={54} y={129} width={14} height={31} rx={7} fill="currentColor" />
    </svg>
  );
};
